import React from 'react';
import { branding } from '../config/branding';

const LOGO_SRC = `${process.env.PUBLIC_URL}/logo.svg`;

export function BrandLogo({ className = '', alt }) {
  return (
    <img
      src={LOGO_SRC}
      alt={alt || branding.productName}
      className={['brand-mark', className].filter(Boolean).join(' ')}
      width={40}
      height={40}
      decoding="async"
    />
  );
}
